module.exports = __webpack_public_path__ + "840ab53b13a49e264e9e6201b633af22.svg";